'use client'

import React from "react";
import {cn} from "@/lib/utils";

export default function DecorationLine({
  style = "dark",
  orientation = "vertical",
  position,
  className = ""
}: {
  style?: "dark" | "light";
  orientation?: "vertical" | "horizontal";
  position?: "left" | "right";
  className?: string;
}){

  return (
    <div className={cn(
      "absolute pointer-events-none",
      orientation === "vertical" ? "h-full border-x" : "w-full border-y",
      style === "dark" ? "border-l-[#202223]/[.15] border-t-[#202223]/[.15] border-r-white border-b-white" : "border-l-black border-t-black border-r-white/[.08] border-b-white/[.08]",
      position === "left" ? "left-[1rem] sm:left-[3rem] lg:left-[7rem] top-0" : position === "right" ? "right-[1rem] sm:right-[3rem] lg:right-[7rem] top-0" : "",
      className
    )}/>
  );
}